import { render, staticRenderFns } from "./SchoolPicker.vue?vue&type=template&id=4709beda&scoped=true&"
import script from "./SchoolPicker.vue?vue&type=script&lang=js&"
export * from "./SchoolPicker.vue?vue&type=script&lang=js&"
import style0 from "./SchoolPicker.vue?vue&type=style&index=0&id=4709beda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4709beda",
  null
  
)

export default component.exports